import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';
import { useHasFeatureFlag } from '~/modules/common/hooks';

export const RESOURCE_REQUEST_MATCHES_QUERY = gql`
  query ResourceRequestMatches(
    $resourceRequestUri: String!
    $page: Int!
    $pageSize: Int!
  ) {
    resourceRequest(id: $resourceRequestUri) {
      id
      resourceMatches(page: $page, pageSize: $pageSize) {
        id
        userUri
        displayText
        score
        role
        availabilityPercentageInDateRange
      }
      resourceMatchesStatus
    }
  }
`;

export const useResourceRequestMatches = ({
  page,
  pageSize,
  resourceRequestUri
}) => {
  const isPsaPraaResourceMatchingEnabled = useHasFeatureFlag({
    featureFlag: 'isPsaPraaResourceMatchingEnabled'
  });

  const { loading, data } = useQuery(RESOURCE_REQUEST_MATCHES_QUERY, {
    variables: {
      page,
      pageSize,
      resourceRequestUri
    },
    skip: !isPsaPraaResourceMatchingEnabled,
    fetchPolicy: 'cache-first'
  });

  return {
    loading,
    resourceMatches: data?.resourceRequest?.resourceMatches,
    resourceMatchesStatus: data?.resourceRequest?.resourceMatchesStatus
  };
};

export default useResourceRequestMatches;
